import React from "react";
import styles from "./Loading.module.css";

type LoadingProps = {
  relative?: boolean;
  absolute?: boolean;
  dark?: boolean;
  black?: boolean;
  green?: boolean;
  fade?: boolean;
  small?: boolean;
  xsmall?: boolean;
  className?: string;
};

export function Loading({
  relative,
  absolute,
  dark,
  black,
  green,
  fade,
  small,
  xsmall,
  className,
}: LoadingProps) {
  return (
    <div
      className={`
      ${styles.Loading}
      ${relative ? styles["Loading-relative"] : ""}
      ${absolute ? styles["Loading-absolute"] : ""}
      ${dark ? styles["Loading-dark"] : ""}
      ${black ? styles["Loading-black"] : ""}
      ${green ? styles["Loading-green"] : ""}
      ${fade ? styles["Loading-fade"] : ""}
      ${small ? styles["Loading-small"] : ""}
      ${xsmall ? styles["Loading-xsmall"] : ""}
      ${className ? className : ""}
      `}
    >
      <span className={`${styles["Loading-indicator"]}`}></span>
    </div>
  );
}
